module.exports = __webpack_public_path__ + "img/logo.b308c854.png";